module.exports = __webpack_public_path__ + "static/media/Work Day Scheduler.ea253d25.gif";